import React from 'react';
import { Leaf, Facebook, Twitter, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-950 text-gray-300 pt-16 pb-8" data-id="element-79">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-80">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-81">
          {/* Brand */}
          <div className="lg:col-span-1" data-id="element-82">
            <a href="#home" className="flex items-center gap-2 mb-6" data-id="element-83">
              <div className="bg-emerald-600 p-2 rounded-lg" data-id="element-84">
                <Leaf className="h-6 w-6 text-white" data-id="element-85" />
              </div>
              <span className="text-xl font-bold text-white tracking-tight" data-id="element-86">
                Green Valley
              </span>
            </a>
            <p className="text-gray-400 mb-6 leading-relaxed" data-id="element-87">
              Professional lawn care and landscaping services dedicated to
              making your property beautiful, healthy, and vibrant year-round.
            </p>
            <div className="flex gap-4" data-id="element-88">
              <a href="#" className="h-10 w-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-emerald-600 hover:text-white transition-colors" aria-label="Facebook" data-id="element-89">
                <Facebook className="h-5 w-5" data-id="element-90" />
              </a>
              <a href="#" className="h-10 w-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-emerald-600 hover:text-white transition-colors" aria-label="Twitter" data-id="element-91">
                <Twitter className="h-5 w-5" data-id="element-92" />
              </a>
              <a href="#" className="h-10 w-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-emerald-600 hover:text-white transition-colors" aria-label="Instagram" data-id="element-93">
                <Instagram className="h-5 w-5" data-id="element-94" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-95">
            <h4 className="text-white font-bold text-lg mb-6" data-id="element-96">Quick Links</h4>
            <ul className="space-y-4" data-id="element-97">
              <li data-id="element-98">
                <a href="#home" className="hover:text-emerald-400 transition-colors" data-id="element-99">
                  Home
                </a>
              </li>
              <li data-id="element-100">
                <a href="#about" className="hover:text-emerald-400 transition-colors" data-id="element-101">
                  About Us
                </a>
              </li>
              <li data-id="element-102">
                <a href="#services" className="hover:text-emerald-400 transition-colors" data-id="element-103">
                  Our Services
                </a>
              </li>

              <li data-id="element-104">
                <a href="#contact" className="hover:text-emerald-400 transition-colors" data-id="element-105">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-106">
            <h4 className="text-white font-bold text-lg mb-6" data-id="element-107">Our Services</h4>
            <ul className="space-y-4" data-id="element-108">
              <li data-id="element-109">
                <a href="#services" className="hover:text-emerald-400 transition-colors" data-id="element-110">
                  Lawn Mowing
                </a>
              </li>
              <li data-id="element-111">
                <a href="#services" className="hover:text-emerald-400 transition-colors" data-id="element-112">
                  Core Aeration
                </a>
              </li>
              <li data-id="element-113">
                <a href="#services" className="hover:text-emerald-400 transition-colors" data-id="element-114">
                  Fertilization
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-115">
          <p className="text-gray-500 text-sm text-center md:text-left" data-id="element-116">
            &copy; {new Date().getFullYear()} Green Valley Lawncare. All rights
            reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-500" data-id="element-117">
            <a href="#" className="hover:text-white transition-colors" data-id="element-118">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-119">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}